import React, { forwardRef } from 'react';
import { BaseButton } from '../base-button';
import { ButtonProps } from '../../types';
import { BaseButtonSize } from '../../types/base-button.types';

export const Button = forwardRef<HTMLElement, ButtonProps>(({ size, ...rest }, ref) => {
	return <BaseButton ref={ref} {...rest} size={size as BaseButtonSize} />;
});
